import { useNavigate } from "react-router-dom";
import "./UpgradeModal.css";

const UpgradeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>🚫 Trial Limit Reached</h2>

        <p>
          You have reached your free trial limit of <b>10 stocks</b>.
        </p>

        <p className="sub-text">
          Upgrade your plan to unlock unlimited access.
        </p>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn-primary"
            onClick={() => {
              // 👉 navigate to pricing page
              //   window.location.href = "/pricing";
              navigate(-1);
            }}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
